import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  container: {
    height: 'calc(100vh - 72px)',
    marginTop: 72
  },
  subContainer: {
    height: '100%',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  button: {
    width: 150,
    marginTop: 16
  }
});

export default styles;